export function getVideoCoverUrl(videoItem) {
  const {
    coverUrl,
    customCoverUrl
  } = videoItem;
  return customCoverUrl || coverUrl;
}
//# sourceMappingURL=cover.js.map